import React from 'react';
import Container from './Container';
import Presenter from './Presenter';

function CountdownPicker(props){
	return (
		<Container 
			{...props}
			render={(containerProps,otherProps)=>(
				<Presenter 
					{...containerProps}
					{...otherProps}/>
			)}
		/>
	);
}

export default CountdownPicker;

